import { SgdfDeleteButton } from './DeleteButton.js';
window.customElements.define('sgdf-delete-button', SgdfDeleteButton);
//# sourceMappingURL=sgdf-delete-button.js.map